import { useCallback, useState } from "react";
export var useErrorDialog = function (onClose) {
    var _a = useState({
        open: false,
        message: "",
    }), errorData = _a[0], setErrorData = _a[1];
    var showError = useCallback(function (message) {
        setErrorData({ open: true, message: message });
    }, []);
    var closeError = useCallback(function () {
        setErrorData({ open: false, message: "" });
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [onClose]);
    return { errorData: errorData, showError: showError, closeError: closeError };
};
